import { Component } from "react";
import propTypes from "prop-types";

import { auth/* , validUsers */ } from "../Utils/firebase.auth";

export default class Authenticated extends Component {
  state = {
    user: null,
    pending: true
  };

  componentDidMount() {
    this.unsubscribe = auth.onAuthStateChanged((user) => {
      this.setState({ user, pending: false });
    });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const { renderTrue, renderFalse, renderPending } = this.props;
    const { user, pending } = this.state;

    if (pending) {
      return renderPending();
    }
    
    // Uncomment next lines to authorized only authorized users
    // if (user && validUsers.indexOf(user.email) === -1) {
    //   let motif = 'unauthorized';
    //   return renderFalse(motif);
    // }

    return user ? renderTrue(user) : renderFalse();
  }
}

Authenticated.propTypes = {
  renderTrue: propTypes.func.isRequired,
  renderFalse: propTypes.func.isRequired,
  renderPending: propTypes.func.isRequired
};
